import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles/tokens.css';

const params = new URLSearchParams(location.search);
const screen = params.get('screen');
const defaultAuthMode = screen === 'signup' ? 'signup' : 'signin';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App defaultAuthMode={defaultAuthMode} />
    </BrowserRouter>
  </StrictMode>,
);
